import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 30px;

  @media (max-width: 768px) {
    padding: 0;
    flex-direction: column;
  }
`
